@if (!everythingReady) {
  <p-progressSpinner></p-progressSpinner>
}
@if (everythingReady) {
  <div class="grid p-1 m-1"  >
    @if (messages.length > 0) {
      <div class="col-12">
        @for (m of messages; track m; let i = $index) {
          <p-message
            [severity]="m.severity"
            >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
          </p-message>
        }
      </div>
    }
    <div class="col-6"><h2 style="margin-bottom:2px; padding-bottom:0px;">Users</h2></div>
    <div class="col-6">
      <button pButton type="button" (click)="navigateToAddUser()" style="margin-top:20px; float:right; vertical-align:bottom;">
        <i pButtonIcon class="fa fa-plus"></i>
        <span pButtonLabel>Add</span>
      </button>
    </div>
    <div class="col-12">
      <p-table #dt  [columns]="cols" [value]="users" [scrollable]="true" [paginator]="true" [rows]="25" [loading]="!usersReady" sortField="companyNames">
        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field" [style.max-width]="col.width" >
                {{col.header}}
                @if (col.field != 'isEmployee' && col.field != 'allCompanies' && col.field != '') {
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                }
              </th>
            }
          </tr>
          <tr>
            <th>
              <div>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'email', 'contains')"
                  />
                </div>
              </th>
              <th>
                <div >
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'name', 'contains')"  />
                </div>
              </th>
              <th>
                <div >
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'companyNames', 'contains')" />
                </div>
              </th>
              <th [style.max-width]="'90px'"></th>
            </tr>
          </ng-template>
          <ng-template #body let-user>
            <tr>
              <td>{{user.email}}</td>
              <td>{{user.name}}</td>
              <td>{{user.companyNames}}</td>
              <td style="max-width: 90px;">
                <i class="fas fa-edit fa-lg" (click)="navigateToDetail(user.id)" style="margin-right:5px;"></i>
                @if (isSuperAdmin()) {
                  <i class="fas fa-trash-alt fa-lg" (click)="confirmDelete(user)"></i>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template #paginatorleft>
            Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
            {{(dt.totalRecords) > 0 ? (((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
            (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
          </ng-template>
        </p-table>
      </div>
    </div>
  }

